import React from 'react';
import { Box, Tooltip } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import { getSmsState, ManagedUser, SmsStateVariant } from './userDisplayUtils';

interface SmsIndicatorProps {
  user: ManagedUser;
}

type IndicatorStyle = {
  bg: string;
  color: string;
  border: string;
  borderColor?: string;
};

const VARIANT_STYLES: Record<SmsStateVariant, IndicatorStyle> = {
  enabled: { bg: 'success.main', color: '#fff', border: 'none' },
  error: { bg: 'error.main', color: '#fff', border: 'none' },
  disabled: { bg: 'grey.100', color: 'text.secondary', border: '1px solid', borderColor: 'grey.300' },
};

/** 28×28 rounded square SMS status indicator (green enabled, red unverified, neutral disabled). */
const SmsIndicator = ({ user }: SmsIndicatorProps) => {
  const { label, variant } = getSmsState(user);
  const styles = VARIANT_STYLES[variant];

  return (
    <Tooltip title={label}>
      <Box
        aria-label={label}
        sx={{
          width: 28,
          height: 28,
          borderRadius: '6px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: styles.bg,
          color: styles.color,
          border: styles.border,
          borderColor: styles.borderColor,
        }}
      >
        <SmsIcon sx={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
};

export default SmsIndicator;
